import { EventConstants } from "~/assets/constants/ecomApi";

type EventData = Record<string, any>;

// Utility function to recursively clean and transform an object or array
const transformObject = (data: EventData): unknown => {
    if (!data) return {}
    return {
        item_id: data?.code ||"",
        item_name: data?.full_name||"",
        affiliation: "Toolstation Store",
        coupon: "",
        discount: data?.prices?.raw?.discount_value||0,
        index: 0,
        item_brand: data?.brand || "",
        item_category: data?.brand||"",
        item_category2: data?.taxonomies?.[0]?.[1]?.name || null,
        item_category3: data?.taxonomies?.[0]?.[2]?.name || null,
        item_list_name: "Related products",
        item_list_id: "related_products",
        item_variant: data?.pack_size || "Unknown_Variant",
        location_id: "",    
        price: data?.prices?.raw.gross || 0,
        price_excluding_tax: data?.prices?.raw.net || 0,
        quantity: parseInt(data?.pack_quantity || '1')
    };
};

// Main function to handle banner clicks
export const bannerClick = (data: EventData, name: string): void => {
    const productData = transformObject(data);

    const ecommerceData = data?.code
        ? {
              currency: EventConstants.currency,
              value: data?.prices?.raw.gross,
              value_excluding_tax: data?.prices?.raw.net,
              item_list_name: "Related products",
              item_list_id: "related_products",
              items: [productData],
          }
        : {
              item_list_name: "Related products",
              item_list_id: "related_products",
          };

    logEvent({
        options: {
            eventAction: "click",
            eventProperties: "",
            ecommerce: ecommerceData,
            eventInteraction: true,
            eventLabel: `Banner click from ${name}`,
            eventName: "banner_click",
        },
    });

    logEvent({
        options: {
            eventAction: "click",
            eventProperties: "",
            ecommerce: ecommerceData,
            eventInteraction: true,
            eventLabel: `Banner click from ${name}`,
            eventName: "select_promotion",
        },
    });
};

export const bannerView = (data: EventData, name: string): void => {
    const productData = transformObject(data);

    const ecommerceData = data?.code
        ? {
              currency: EventConstants.currency,
              value: data?.prices?.raw.gross,
              value_excluding_tax: data?.prices?.raw.net,
              item_list_name: "Related products",
              item_list_id: "related_products",
              items: [productData],
          }
        : {
              item_list_name: "Related products",
              item_list_id: "related_products",
          };

    logEvent({
        options: {
            eventAction: "scroll",
            eventProperties: "",
            ecommerce: ecommerceData,
            eventInteraction: true,
            eventLabel: `Banner view: ${name}`,
            eventName: "view_promotion",
        },
    });
};

